import * as React from 'react';
import TablePagination from '@mui/material/TablePagination';
import PageableDto from "../../dto/PageableDto";
import {Grid, InputAdornment, TextField} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import {rowsPerPageOptions} from "../../constants/pagination";
import ClearIcon from "@mui/icons-material/Clear";
import {useTranslation} from "react-i18next";
import ExpenseDto from "../../dto/ExpenseDto";
import ExpenseListRow from "../expense-list-row/expense-list-row";
import Table from "@mui/material/Table";
import TableFooter from "@mui/material/TableFooter";
import TableRow from "@mui/material/TableRow";

interface Props {
    pageable: PageableDto<ExpenseDto[]>;
    query: string;
    page: number;
    pageSize: number;
    onChangePage: (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => void;
    onChangePageSize: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    loadData: () => void;
    onChangeQuery: any;
}

export default function ExpenseList(props: Props) {
    const {t} = useTranslation();
    const {
        pageable,
        query,
        page,
        pageSize,
        onChangePage,
        onChangePageSize,
        loadData,
        onChangeQuery
    } = props;

    const onClearQuery = () => {
        var simulatedEvent = {
            target: {
                value: ''
            }
        };
        onChangeQuery(simulatedEvent);
    };

    return (
        <div>
            {pageable?.content
                ?
                <div>
                    <Box sx={{paddingTop: '1%', paddingBottom: '1%'}} mb={1}>
                        <TextField fullWidth
                                   id="search-query"
                                   label={t('Search')}
                                   variant="outlined"
                                   value={query}
                                   onChange={onChangeQuery}
                                   InputProps={{
                                       endAdornment: <InputAdornment position="end"><IconButton
                                           aria-label={`${t('Clear search value')}`}
                                           onClick={onClearQuery}
                                           edge="end"
                                           disabled={query.length === 0}
                                       >
                                           <ClearIcon/>
                                       </IconButton></InputAdornment>,
                                   }}
                        />
                    </Box>
                    <Grid container spacing={2}>
                        {pageable.content.map((row, rowIndex) => (
                            <ExpenseListRow
                                key={`${row.id}`}
                                rowIndex={rowIndex}
                                row={row}
                                onChange={loadData}
                            />
                        ))}
                    </Grid>

                    <Box mt={1}>
                        <Table>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={rowsPerPageOptions}
                                        colSpan={3}
                                        count={pageable.totalElements}
                                        rowsPerPage={pageSize}
                                        page={page}
                                        SelectProps={{
                                            inputProps: {
                                                'aria-label': `${t('rows per page')}`,
                                            },
                                            native: true,
                                        }}
                                        onPageChange={onChangePage}
                                        onRowsPerPageChange={onChangePageSize}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>

                    </Box>
                </div> : <p>{t('No data')}</p>}
        </div>
    );
}